// AI model override catalog — pure data shared by the v3 ChooseAIModelModal
// and the v4 ChooseAIModelPanel (DT1 dev-tools tab; single source, no antd).
export interface ModelData {
  name: string;
  value: string;
  disabled?: boolean;
  schoolSelectable?: boolean;
}

export interface ModelOptionsData {
  [key: string]: ModelData[];
}

export const modelOptions: ModelOptionsData = {
  'OpenAI GPT': [
    { name: 'O3', value: 'O3' },
    { name: 'O4-mini-high', value: 'O4-mini-high' },
    { name: 'O1', value: 'O1' },
    // {name: "O1-mini [Text]", value: "O1-mini"},
    { name: 'O3-mini [Text]', value: 'O3-mini' },
    { name: 'GPT 4o', value: 'GPT4o', schoolSelectable: true },
    { name: 'GPT 4-turbo', value: 'GPT4-turbo' },
    { name: 'GPT 4', value: 'GPT4' },
    { name: 'GPT 3.5', value: 'GPT3.5' },
  ],
  'Anthropic Claude': [
    // The following models have been deprecated
    // { name: 'Claude 3.5 Sonnet', value: 'Claude3.5-sonnet', schoolSelectable: true },
    // { name: 'Claude 3 Opus', value: 'Claude3-opus', schoolSelectable: true },
    // { name: 'Claude 3 Sonnet', value: 'Claude3-sonnet' },
    { name: 'Claude 3 Haiku', value: 'Claude3-haiku' },
  ],
  'Google Gemini': [
    { name: 'Gemini 2.0 Pro', value: 'Gemini-2-pro' },
    { name: 'Gemini 2.0 Flash thinking', value: 'Gemini-2-flash-thinking' },
    { name: 'Gemini 2.0 Flash', value: 'Gemini-2-flash' },
    { name: 'Gemini 1.5 Pro', value: 'Gemini-1.5-pro', schoolSelectable: true },
    { name: 'Gemini 1.5 Flash', value: 'Gemini-1.5-Flash' },
  ],
};
